import { type SearchPreloadDataProvider } from '../../../common/types/search-preload';
import { type DisposableValue } from '../../../common/utils/disposable-value';

export const reconcileSsrSearchSessionId = (
	searchSessionId: DisposableValue<string>,
	cloudId: string | null | undefined,
	preloadDataProvider?: SearchPreloadDataProvider,
): void => {
	if (!cloudId || !preloadDataProvider) {
		return;
	}

	const preloadedSearchSessionId = preloadDataProvider.getPreloadedSearch({ cloudId })?.search
		?.generated?.searchSessionId;
	const currentSearchSessionId = searchSessionId.value();

	if (preloadedSearchSessionId && preloadedSearchSessionId !== currentSearchSessionId) {
		searchSessionId.update(preloadedSearchSessionId);
	}
};
